import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { Users, CircuitBoard, Cone, Grid2X2Plus } from "lucide-react";
import { useQuery } from "../AppLayout";
import GeneralSetting from "./GeneralSetting";
import MemberSetting from "./MemberSetting";
import SaleFunnelSetting from "./SaleFunnelSetting";
import DataSetting from "./DataSetting";
import SettingTabs from "../team/component/SettingTabs";

const PipelineSetting = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { projectId }: any = useParams();
  const currentParams = useQuery();

  const settingType = currentParams.get("item") || "general";

  useEffect(() => {
    document.title = t("Team Setting");
  }, [t]);

  const onSettingTypeChange = (type) => {
    navigate(`/workspaces/${projectId}/settings/pipeline?item=${type}&key=Pipeline%20Settings`);
  };

  const tabs = [
    {
      id: "general",
      label: t("General"),
      icon: <CircuitBoard className="w-4 h-4" />,
    },
    {
      id: "member",
      label: t("Members"),
      icon: <Users className="w-4 h-4" />,
    },
    {
      id: "salefunnel",
      label: t("Sale Funnels"),
      icon: <Cone className="w-4 h-4" />,
    },
    {
      id: "data",
      label: t("Data"),
      icon: <Grid2X2Plus className="w-4 h-4" />,
    },
  ];

  return (
    <div className={"p-4"}>
      <SettingTabs tabs={tabs} activeTabId={settingType} onTabChange={onSettingTypeChange} />
      {settingType === "general" ? <GeneralSetting /> : null}
      {settingType === "member" ? <MemberSetting /> : null}
      {settingType === "salefunnel" ? <SaleFunnelSetting /> : null}
      {settingType === "data" ? <DataSetting /> : null}
    </div>
  );
};

export default PipelineSetting;
